class LockedCollectionForm extends HTMLElement {
  constructor () {
    super()

    this.state = {
      isLocked: true,
    }

    this.els = {
      form: this.querySelector('form'),
    }
  }

  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.els.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  async handleSubmit (event) {
    event.preventDefault()

    await this.postCartAttribute(this.cartKey, true)

    this.isLocked = false
  }

  async postCartAttribute (key, value) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Failed to update cart attribute:', error)
    }
  }

  get isLocked () {
    return this.state.isLocked
  }

  get cartKey () {
    return this.dataset.cartKey
  }

  set isLocked (value) {
    this.state.isLocked = value

    if (!value) {
      this.els.form.submit()
    }
  }
}

customElements.define('locked-collection-form', LockedCollectionForm)
